module.exports = __webpack_public_path__ + "static/media/healthFirst.79908a96.png";